<template>
    <div>
        <div class="d-flex flex-column align-items-center">
            <!-- Common main element parameters -->
            <div
                v-for="(parameter, elementKey) in app.currentConfiguration
                    .commonMainElementParameters"
                style="border: 0px solid black; background-color: white"
                :key="parameter.attribute.id"
                class="p-3"
            >
                <editParameterValueComponent
                    ref="editParameterValueComponent"
                    :labelOverInput="isMobile ? true : false"
                    :parameter="parameter"
                    :value.sync="parameter.value"
                    @update:value="refreshParameters"
                ></editParameterValueComponent>
            </div>

            <!-- Iterate mainElements -->
            <div
                v-for="(mainElementParameters, key, i) in app
                    .currentConfiguration.mainElementParameters"
                :key="i"
            >
                <div
                    class="card mb-5"
                    :style="!isMobile ? 'min-width:650px' : ''"
                >
                    <!-- METROS -->
                    <div
                        class="
                            card-header
                            d-flex
                            justify-content-between
                            align-items-center
                            pt-2
                            pb-2
                        "
                        style="background: #dcdcdc"
                    >
                        <editParameterValueComponent
                            :parameter="
                                mainElementParameters['metros_por_tramo']
                            "
                            :value.sync="
                                mainElementParameters['metros_por_tramo'].value
                            "
                            :placeholder_titel="
                                mainElementParameters['metros_por_tramo']
                                    .attribute.name
                            "
                            :labelOverInput="false"
                            :prop_title_show="true"
                            @update:value="refreshParameters"
                        ></editParameterValueComponent>

                        <!-- REMOVE BUTTON -->
                        <button
                            :class="
                                isMobile
                                    ? 'btn_mobile_size'
                                    : 'btn_desktop_size'
                            "
                            @click.stop="removeCanal(key)"
                            class="btn btn-outline-dark btn_rounded"
                        >
                            <i
                                v-if="buttonRemoving"
                                class="fa fa-spinner fa-spin"
                            ></i>
                            <i v-else class="fas fa-minus fa-sm"></i>
                        </button>
                    </div>

                    <div
                        v-for="(tapas, index, name) in crossTapasDimensiones"
                        :key="index"
                    >
                        <!-- HEADER TAPAS -->
                        <div
                            class="
                                card-header
                                d-flex
                                justify-content-between
                                align-items-center
                                pt-2
                                pb-2
                            "
                        >
                            <div>
                                <span
                                    v-show="
                                        mainElementParameters['numero_tapas']
                                            .value.id === tapas.id &&
                                        mainElementParameters['dimensiones']
                                            .value &&
                                        mainElementParameters[
                                            'opcion_compartimento'
                                        ].value
                                    "
                                >
                                    <i
                                        class="
                                            size_check_desktop
                                            fa-lg
                                            far
                                            fa-check-circle
                                            ml-1
                                            mr-3
                                        "
                                        style="color: black"
                                    ></i>
                                </span>
                            </div>

                            <div>
                                <span class="p-2 mr-3 font-weight-bold">{{
                                    tapas.name
                                }}</span>
                                <img
                                    style="
                                        width: 135px;
                                        height: auto;
                                        transform: rotate(0deg);
                                    "
                                    :src="
                                        getCroquisImgTapas_rectangular(tapas.id)
                                    "
                                />
                            </div>

                            <button
                                style="
                                    font-weight: lighter;
                                    border-radius: 50%;
                                    width: 40px;
                                    height: 40px;
                                    visibility: hidden;
                                "
                                @click.stop="cleanAllSelectors()"
                                class="btn btn-outline-secondary ml-2"
                            >
                                <i class="fas fa-trash-alt"></i>
                            </button>
                        </div>

                        <div class="card-body py-3">
                            <!-- MOBILE -->
                            <div
                                v-if="isMobile"
                                class="
                                    d-flex
                                    flex-column
                                    justify-content-center
                                    align-items-center
                                "
                            >
                                <div
                                    class="
                                        d-flex
                                        flex-row
                                        justify-content-start
                                        align-items-between
                                    "
                                >
                                    <!-- selectors dimensio -->
                                    <div
                                        v-if="tapas && tapas.childs.length > 0"
                                        class="
                                            d-flex
                                            flex-column
                                            align-items-start
                                            justify-content-center
                                            mr-2
                                        "
                                    >
                                        <div
                                            v-for="(
                                                dimension, name, index
                                            ) in tapas.childs"
                                            :key="index"
                                            class="
                                                d-flex
                                                flex-row
                                                align-items-center
                                                justify-content-center
                                                custom-control custom-radio
                                                mb-1
                                            "
                                        >
                                            <!-- style="background-color:red;" -->
                                            <input
                                                type="radio"
                                                :id="
                                                    'd' +
                                                    i +
                                                    '_' +
                                                    tapas.id +
                                                    '_' +
                                                    dimension.id
                                                "
                                                :name="
                                                    i +
                                                    'compartimento_dimension'
                                                "
                                                :value="[
                                                    tapas.id,
                                                    dimension.id,
                                                ]"
                                                :disabled="app.isProcessing"
                                                :checked="
                                                    isChecked(
                                                        mainElementParameters,
                                                        tapas,
                                                        dimension,
                                                        null
                                                    )
                                                "
                                                @change="
                                                    onCheckChanged(
                                                        mainElementParameters,
                                                        tapas,
                                                        dimension,
                                                        null,
                                                        i
                                                    )
                                                "
                                                class="custom-control-input"
                                            />

                                            <label
                                                :for="
                                                    'd' +
                                                    i +
                                                    '_' +
                                                    tapas.id +
                                                    '_' +
                                                    dimension.id
                                                "
                                                class="custom-control-label"
                                                style="background-color: white"
                                                >{{ dimension.name }}</label
                                            >
                                        </div>
                                    </div>

                                    <!-- selectors compartimentos -->
                                    <div
                                        class="
                                            d-flex
                                            flex-column
                                            align-items-start
                                            justify-content-center
                                            mr-0
                                            ml-2
                                            my-2
                                        "
                                        v-if="
                                            crossTapasCompartimentos[index] &&
                                            crossTapasCompartimentos[index]
                                                .childs.length > 0
                                        "
                                    >
                                        <div
                                            v-for="(
                                                compartimento, name, index2
                                            ) in crossTapasCompartimentos[index]
                                                .childs"
                                            :key="index2"
                                            class="
                                                d-flex
                                                flex-row
                                                align-items-start
                                                justify-content-start
                                                custom-control custom-radio
                                                mb-1
                                            "
                                        >
                                            <input
                                                type="radio"
                                                :id="
                                                    'c' +
                                                    i +
                                                    '_' +
                                                    tapas.id +
                                                    '_' +
                                                    compartimento.id
                                                "
                                                :name="
                                                    i + 'tapas_compartimentos'
                                                "
                                                :value="[
                                                    tapas.id,
                                                    compartimento.id,
                                                ]"
                                                :disabled="
                                                    app.isProcessing ||
                                                    !getParameter(
                                                        mainElementParameters,
                                                        'opcion_compartimento',
                                                        compartimento.id
                                                    ).status
                                                "
                                                :checked="
                                                    isChecked(
                                                        mainElementParameters,
                                                        tapas,
                                                        null,
                                                        compartimento
                                                    )
                                                "
                                                @change="
                                                    onCheckChanged(
                                                        mainElementParameters,
                                                        tapas,
                                                        null,
                                                        compartimento,
                                                        i
                                                    )
                                                "
                                                class="custom-control-input"
                                            />

                                            <label
                                                :for="
                                                    'c' +
                                                    i +
                                                    '_' +
                                                    tapas.id +
                                                    '_' +
                                                    compartimento.id
                                                "
                                                class="custom-control-label"
                                                style="background-color: white"
                                                >{{ compartimento.name }}</label
                                            >
                                        </div>
                                    </div>
                                </div>

                                <!-- imatge per mobil -->
                                <img
                                    style="width: 200px; height: auto"
                                    class="m-1"
                                    :src="
                                        getParameter(
                                            mainElementParameters,
                                            'numero_tapas',
                                            tapas.id
                                        ).image
                                    "
                                    v-show="
                                        getParameterValueId(
                                            mainElementParameters,
                                            'numero_tapas'
                                        ) == tapas.id
                                    "
                                />
                            </div>

                            <!-- DESKTOP -->
                            <div v-else>
                                <div
                                    class="d-flex flex-row"
                                    :class="
                                        isMobile
                                            ? 'justify-content-center align-items-center'
                                            : 'justify-content-between align-items-between'
                                    "
                                >
                                    <!-- selectors dimensio -->
                                    <div
                                        class="
                                            d-flex
                                            flex-column
                                            align-items-start
                                            justify-content-center
                                            m-2
                                            ml-3
                                        "
                                        v-if="tapas && tapas.childs.length > 0"
                                    >
                                        <div
                                            v-for="(
                                                dimension, name, index
                                            ) in tapas.childs"
                                            :key="index"
                                            class="
                                                d-flex
                                                flex-row
                                                align-items-center
                                                justify-content-center
                                                custom-control custom-radio
                                                mb-1
                                            "
                                        >
                                            <input
                                                type="radio"
                                                :id="
                                                    'd' +
                                                    i +
                                                    '_' +
                                                    tapas.id +
                                                    '_' +
                                                    dimension.id
                                                "
                                                :name="
                                                    i +
                                                    '_compartimento_dimension'
                                                "
                                                :value="[
                                                    tapas.id,
                                                    dimension.id,
                                                ]"
                                                :disabled="
                                                    app.isProcessing ||
                                                    !getParameter(
                                                        mainElementParameters,
                                                        'dimensiones',
                                                        dimension.id
                                                    ).status
                                                "
                                                :checked="
                                                    isChecked(
                                                        mainElementParameters,
                                                        tapas,
                                                        dimension,
                                                        null
                                                    )
                                                "
                                                @change="
                                                    onCheckChanged(
                                                        mainElementParameters,
                                                        tapas,
                                                        dimension,
                                                        null,
                                                        i
                                                    )
                                                "
                                                class="custom-control-input"
                                            />

                                            <label
                                                :for="
                                                    'd' +
                                                    i +
                                                    '_' +
                                                    tapas.id +
                                                    '_' +
                                                    dimension.id
                                                "
                                                class="
                                                    custom-control-label
                                                    text-left
                                                "
                                                style="background-color: white"
                                                >{{ dimension.name }}</label
                                            >
                                        </div>
                                    </div>

                                    <!-- imatge canal 93 per escriptori-->
                                    <img
                                        style="max-width: 320px; height: auto"
                                        class="m-2"
                                        :src="
                                            getParameter(
                                                mainElementParameters,
                                                'numero_tapas',
                                                tapas.id
                                            ).image
                                        "
                                        v-show="
                                            getParameterValueId(
                                                mainElementParameters,
                                                'numero_tapas'
                                            ) == tapas.id
                                        "
                                    />

                                    <!-- selectors compartimentos -->
                                    <div
                                        class="
                                            d-flex
                                            flex-column
                                            align-items-start
                                            justify-content-center
                                            my-2
                                            mr-2
                                            ml-0
                                        "
                                        v-if="
                                            crossTapasCompartimentos[index] &&
                                            crossTapasCompartimentos[index]
                                                .childs.length > 0
                                        "
                                    >
                                        <div
                                            v-for="(
                                                compartimento, name, index2
                                            ) in crossTapasCompartimentos[index]
                                                .childs"
                                            :key="index2"
                                            class="
                                                d-flex
                                                flex-row
                                                align-items-center
                                                justify-content-center
                                                custom-control custom-radio
                                                mb-1
                                            "
                                        >
                                            <input
                                                type="radio"
                                                :id="
                                                    'c' +
                                                    i +
                                                    '_' +
                                                    tapas.id +
                                                    '_' +
                                                    compartimento.id
                                                "
                                                :name="
                                                    i + '_tapas_compartimentos'
                                                "
                                                :value="[
                                                    tapas.id,
                                                    compartimento.id,
                                                ]"
                                                :disabled="
                                                    app.isProcessing ||
                                                    !getParameter(
                                                        mainElementParameters,
                                                        'opcion_compartimento',
                                                        compartimento.id
                                                    ).status
                                                "
                                                :checked="
                                                    isChecked(
                                                        mainElementParameters,
                                                        tapas,
                                                        null,
                                                        compartimento
                                                    )
                                                "
                                                @change="
                                                    onCheckChanged(
                                                        mainElementParameters,
                                                        tapas,
                                                        null,
                                                        compartimento,
                                                        i
                                                    )
                                                "
                                                class="custom-control-input"
                                            />

                                            <label
                                                :for="
                                                    'c' +
                                                    i +
                                                    '_' +
                                                    tapas.id +
                                                    '_' +
                                                    compartimento.id
                                                "
                                                class="
                                                    custom-control-label
                                                    text-left
                                                "
                                                style="background-color: white"
                                                >{{ compartimento.name }}</label
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- ------------- -->
            <!-- ADD BUTTON -->
            <!-- ------------- -->
            <button
                @click="addCanal()"
                class="btn btn-outline-dark btn_rounded"
                :class="isMobile ? 'btn_mobile_size' : 'btn_desktop_size'"
            >
                <i v-if="buttonLoading" class="fa fa-spinner fa-spin"></i>
                <i
                    v-else
                    class="fas fa-plus fa-sm"
                    :class="isMobile ? 'iconMobile' : ''"
                ></i>
            </button>
        </div>
    </div>
</template>

<script>
import { app } from "../../application.js";
import editParameterValueComponent from "./../editParameterValue.vue";
import mainElementsGenericComponent from "./mainElementsGeneric.vue";

export default {
    extends: mainElementsGenericComponent,
    name: "mainElements93Component",
    data() {
        return {
            app: app,
            confirmBeforeLeave: true,
            parameters: [],
            mainElementDistribution: "",
            buttonLoading: false,
            buttonRemoving: false,
            labelOverDropdown: true,
            crossTapasDimensiones: [],
            crossTapasCompartimentos: [],
            window: { width: 0, height: 0 },
            croquis_1_tapa: require("@/assets/images/gamas/93/croquis_1_tapa.png"),
            croquis_2_tapa: require("@/assets/images/gamas/93/croquis_2_tapa.png"),
            croquis_3_tapa: require("@/assets/images/gamas/93/croquis_3_tapa.png")
        };
    },
    components: {
        editParameterValueComponent,
        mainElementsGenericComponent
    },
    computed: {
        isMobile: function () {
            let a = this.window.width < 650;
            return a;
        },
        isMobileXS: function () {
            let a = this.window.width < 340;
            return a;
        },
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        cleanAllSelectors: async function () {
            //loop through mainElementParameters values resetting all selected values in currentConfiguration.mainElementParameters
            let mainparams = this.app.currentConfiguration
                .mainElementParameters;

            Object.values(mainparams).map(mainparam => {
                Object.values(mainparam).map(item => {
                    if (item.value.constructor.name == "Array") {
                        item.value = [];
                    } else {
                        item.value = "";
                    }
                });
            });

            this.refreshParameters();

        },
        refreshParameters: async function () {
            this.app.asyncProcess(false, false);
            // await this.refreshCrossOptions(Object.keys(app.currentConfiguration.mainElementParameters)[0]);
        },
        getCroquisImgTapas_rectangular: function (numero_tapas_id) {
            if (numero_tapas_id === "tapas-1") {
                return this.croquis_1_tapa;

            } else if (numero_tapas_id === "tapas-2") {
                return this.croquis_2_tapa;

            } else if (numero_tapas_id === "tapas-3") {
                return this.croquis_3_tapa;
            }
        },
        getParameter: function (mainElement, parameter, id) {
            let parameterValues = mainElement[parameter].values;

            for (const value of parameterValues) {
                if (value.id === id) {
                    return value;
                }
            }

            return new Object();
        },

        getParameterValueId: function (mainElement, parameter) {
            let parameter1 = mainElement[parameter];

            if (parameter1.value) return parameter1.value.id;

            return null;
        },

        refreshCrossOptions: async function (elementKey) {

            //console.log('elementKey:', elementKey);

            // tapas x compartimentos
            this.crossTapasCompartimentos = await this.app.API.crossOptions(
                elementKey,
                "numero_tapas,opcion_compartimento",
                1
            );

            // tapas x dimensiones
            this.crossTapasDimensiones = await this.app.API.crossOptions(
                elementKey,
                "numero_tapas,dimensiones",
                1
            );

            this.app.isSpinnerAlwaysVisible = false;
            this.app.hideSpinner();

        },

        isChecked: function (mainElement, tapas, dimension, compartimentos) {

            let selected_tapas = mainElement["numero_tapas"];
            let selected_compartimentos = mainElement["opcion_compartimento"];
            let selected_dimension = mainElement["dimensiones"];

            let selected_tapas_id = null;
            let selected_compartimento_id = null;
            let selected_dimension_id = null;

            if (selected_tapas.value)
                selected_tapas_id = selected_tapas.value.id;
            if (selected_compartimentos.value)
                selected_compartimento_id = selected_compartimentos.value.id;
            if (selected_dimension.value)
                selected_dimension_id = selected_dimension.value.id;

            // tapa/dimension
            if (
                selected_dimension_id &&
                dimension &&
                selected_tapas_id == tapas.id &&
                selected_dimension_id == dimension.id
            )
                return true;

            // tapas/compartimentos
            if (
                selected_compartimento_id &&
                compartimentos &&
                selected_tapas_id == tapas.id &&
                selected_compartimento_id == compartimentos.id
            ) {
                return true;
            }
        },

        onCheckChanged: async function (
            mainElement,
            tapas,
            dimension,
            compartimentos,
            elementKey
        ) {
            console.warn(mainElement["metros_por_tramo"].value)

            // Detectar si s'ha canviat de grup de "tapas"
            let tapasChanged = false
            if (
                (!mainElement["numero_tapas"].value)
                ||
                (mainElement["numero_tapas"].value && mainElement["numero_tapas"].value.id != tapas.id)) {
                tapasChanged = true
                let newTapasValue = this.getParameter(
                    mainElement,
                    "numero_tapas",
                    tapas.id
                );

                mainElement["numero_tapas"].value = newTapasValue
            }
            if (dimension) {
                mainElement["dimensiones"].value = this.getParameter(
                    mainElement,
                    "dimensiones",
                    dimension.id
                );
                // TODO: mirar quan fer aixo...
                if( tapasChanged ){
                    mainElement["opcion_compartimento"].value = null;
                }
            }
            if (compartimentos) {
                // mainElement["numero_tapas"].value = this.getParameter(
                //     mainElement,
                //     "numero_tapas",
                //     tapas.id
                // );
                mainElement["opcion_compartimento"].value = this.getParameter(
                    mainElement,
                    "opcion_compartimento",
                    compartimentos.id
                );
                if( tapasChanged ){
                    mainElement["dimensiones"].value = null
                }
            }

            this.refreshParameters();
        },
        addCanal: async function () {

            var self = this;

            this.buttonLoading = true
            let nomBandejaACrear = Object.keys(
                this.app.currentConfiguration.mainElementParameters).length + 1;

            await app.API.addMainElement(nomBandejaACrear);

            this.buttonLoading = false
        },
        removeCanal: async function (key) {
            var self = this;

            //------------------------------------------------------------------------------------
            //espera que Vue vacie la cola asincrónica de actualizaciones del DOM para realizar actualizaciones de DOM -> eliminar bandeja
            //------------------------------------------------------------------------------------
            this.$nextTick(async () => {

                this.buttonRemoving = true
                delete self.app.currentConfiguration.mainElementParameters[
                    key
                ];

                self.renameCanales();

                await app.asyncProcess(false, false);

                self.buttonRemoving = false
            });
            //------------------------------------------------------------------------------------
        },

        renameCanales: function () {
            let newKey = 0;
            Object.entries(
                this.app.currentConfiguration.mainElementParameters
            ).forEach(([key, value]) => {
                newKey += 1;
                if (
                    this.app.currentConfiguration.mainElementParameters.hasOwnProperty(
                        key
                    )
                ) {
                    delete this.app.currentConfiguration.mainElementParameters[
                        key
                    ];
                    this.app.currentConfiguration.mainElementParameters[
                        newKey
                    ] = value;
                }
            });
        },
    },
    created() {
        //get window size
        window.addEventListener("resize", this.handleResize);
        this.handleResize();


    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },

    async beforeMount() {

        var self = this;
        app.showSpinner();

        this.refreshParameters();

        await this.refreshCrossOptions(Object.keys(app.currentConfiguration.mainElementParameters)[0]);

        app.hideSpinner();
    }
};
</script>

<style lang="scss">
</style>
